/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoCircleIcon16Solid = forwardRef('InfoCircleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM9.11 4.763a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM6.583 7.01a.875.875 0 1 0 0 1.75h.625v2.158h-.625a.875.875 0 0 0 0 1.75h1.5l1.497.006a.875.875 0 1 0 .007-1.75l-.629-.002V7.885a.875.875 0 0 0-.875-.875h-1.5Z" })));
});
